var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 10.834C10.4602 10.834 10.8333 10.4609 10.8333 10.0007C10.8333 9.54041 10.4602 9.16732 9.99999 9.16732C9.53975 9.16732 9.16666 9.54041 9.16666 10.0007C9.16666 10.4609 9.53975 10.834 9.99999 10.834Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 5.00065C10.4602 5.00065 10.8333 4.62755 10.8333 4.16732C10.8333 3.70708 10.4602 3.33398 9.99999 3.33398C9.53975 3.33398 9.16666 3.70708 9.16666 4.16732C9.16666 4.62755 9.53975 5.00065 9.99999 5.00065Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 16.6673C10.4602 16.6673 10.8333 16.2942 10.8333 15.834C10.8333 15.3737 10.4602 15.0007 9.99999 15.0007C9.53975 15.0007 9.16666 15.3737 9.16666 15.834C9.16666 16.2942 9.53975 16.6673 9.99999 16.6673Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownDot);
export default __webpack_public_path__ + "static/media/DropdownDot.1ee2086e.svg";
export { ForwardRef as ReactComponent };